import type { ReportMetric } from "./reportTypes"

/** v1 metric types whose outputs are labels rather than numbers. */
const LABEL_METRIC_TYPES = new Set([
  "METRIC_CATEGORICAL",
  "METRIC_LLM_BINARY",
  "METRIC_AUDIO_LLM_BINARY",
  "METRIC_AUDIO_LLM_CATEGORICAL",
  "METRIC_METADATA_FIELD",
])

/**
 * A recipe can group conversations by any metric whose output is a label.
 * The catalog's evaluation contract is authoritative when the API supplies
 * it; older built-in entries fall back to the legacy metric type.
 */
export function isGroupingMetric(metric: ReportMetric): boolean {
  const outputType = metric.evaluation?.output_type
  if (outputType) {
    return outputType === "string"
  }
  return metric.metric_type ? LABEL_METRIC_TYPES.has(metric.metric_type) : false
}

export function groupingMetricOptions(metrics: ReportMetric[]): ReportMetric[] {
  return metrics
    .filter(isGroupingMetric)
    .sort((left, right) => left.name.localeCompare(right.name))
}

export function groupingMetricName(
  metrics: ReportMetric[],
  metricId: string | null | undefined,
): string | undefined {
  if (!metricId) {
    return undefined
  }
  return metrics.find((metric) => metric.id === metricId)?.name
}
